<app-header></app-header>
<app-sidebar></app-sidebar>

<div class="content-wrapper" style="min-height: 307px">

    <section class="content" style="display: block;">
        <div class="card ">
            <div class="card-header bg-primary">
                <h3 class="card-title">ข้อมูลแผนที่ แปลงอ้อย กลุ่มตัด</h3>

                <div class="card-tools">
                    <button type="button " class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i>
                    </button>
                </div>
                <!-- /.card-tools -->
            </div>
            <!-- /.card-header -->
            <div class="card-body" style="display: block;">
                <div class="row" style="text-align:center">
                    <div class="col"></div>
                    <div class="col-md-2">
                        <mat-form-field appearance="fill">
                            <mat-label>เลือกปี</mat-label>
                            <mat-select disableRipple [(ngModel)]="select_year" (selectionChange)="load_group();">
                                <mat-option value="00" disabled>เลือกปี</mat-option>
                                <mat-option *ngFor="let item of selettimes" [value]="item.year">
                                    {{ item.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-md-2">
                        <mat-form-field appearance="fill">
                            <mat-label>เลือกกลุ่ม</mat-label>
                            <mat-select disableRipple [(ngModel)]="select_group" [disabled]="list_group.length==0"
                                multiple>
                                <!--<mat-checkbox [(ngModel)]="selectAllChecked" [ngModelOptions]="{standalone: true}"
                                    (ngModelChange)="toggleSelectAll()">ทุกกลุ่ม</mat-checkbox>-->
                                <mat-option *ngFor="let item of list_group; index as i" [value]="item.groupCode">
                                    กลุ่ม {{item.groupCode}} มี {{item.cntp|number}} แปลง
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-progress-bar *ngIf="loading[1]" mode="indeterminate"></mat-progress-bar>
                        <!--<div *ngFor="let li of select_root">
                                <label class="container">
                                    {{li}}<span class="badge badge-secondary">
                                        <a class='far fa-edit' style='font-size:24;color:red'
                                            (click)="remove_val(li);"> </a>
                                    </span>
                                </label>
                            </div>-->
                    </div>
                    <div class="col-md-2">
                        <div class="button-row">
                            <button mat-raised-button color="primary" (click)="s_group_1();"
                                [disabled]="list_group.length==0">แสดงข้อมูล</button>
                        </div>
                        <mat-progress-bar *ngIf="loading[2]" mode="indeterminate"></mat-progress-bar>
                    </div>
                    <div class="col-md-2">
                        <mat-checkbox [(ngModel)]="showLabels">
                            แสดงชื่อเจ้าของแปลง
                        </mat-checkbox>
                    </div>
                    <div class="col"></div>
                </div>

                <div class="card">
                    <agm-map *ngIf="maps.length>0" [streetViewControl]="false" [latitude]="latlong.lat"
                        [longitude]="latlong.long" [zoom]="14" [maxZoom]="30" [minZoom]="10" [fullscreenControl]="true"
                        [locationButton]="true" [mapTypeId]="'hybrid'">
                        <div *ngFor="let item of maps">
                            <agm-marker [latitude]="item.point.lat" [longitude]="item.point.lng"
                                (markerClick)="selected = item;infordata=item" [label]="showLabels ? item.fmname : ''"
                                [title]="'แปลง ['+ item.landno +'] ของ ' + item.fmname">
                                <!-- Tooltip เมื่อเอาเมาส์ชี้ -->
                                <agm-info-window>
                                    <div style="font-size: 12px; line-height: 1.2; margin: 0; padding: 0;">
                                        <p style="margin: 2px 0;">เลขแปลง: <strong>{{ item.landno }}</strong>
                                        </p>
                                        <p style="margin: 2px 0;">ชื่อชาวไร่: <strong>{{ item.fmname }}</strong></p>
                                        <p style="margin: 2px 0;">พื้นที่: <strong>{{ item.landvalue }}</strong></p>
                                        <p style="margin: 2px 0;">ประเภทอ้อย: <strong>{{ item.CaneTypeName
                                                }}</strong></p>
                                        <p style="margin: 2px 0;">โซน: <strong>{{ item.ZoneId }}</strong></p>
                                        <p style="margin: 2px 0;">กลุ่มตัด: <strong>{{ item.groupCode }}</strong>
                                        </p>
                                        <p style="margin: 2px 0;">วันที่ปลูก: <strong>{{ item.plantdate | adtob
                                                }}</strong></p>
                                        <p style="margin: 2px 0;">อายุ: <strong>{{ item.caneage }} วัน</strong></p>
                                    </div>
                                </agm-info-window>
                            </agm-marker>

                            <agm-polygon *ngIf="item.coordinates" [paths]="item.coordinates" [strokeColor]="'#44FFD1'"
                                [fillColor]="colorclick">
                            </agm-polygon>
                            <!-- 
                                    <agm-circle *ngif="current" [latitude]="lat" [longitude]="lng" [radius]="50"
                                    [fillColor]="'blue'" [circleDraggable]="false" [editable]="false"></agm-circle>
                                -->
                        </div>
                    </agm-map>

                </div>
            </div>
            <!-- /.card-body -->
        </div>
        <!-- /.card -->

    </section>
</div>
<app-footer></app-footer>